import languageDataMutations from "./mutations.js";
import languageDataActions from "./actions.js";
import languageDataGetters from "./getters.js";

export default {
    namespaced: true,
    state() {
        return {
            // startUpDataDetails: {}
            languageDetails:{},
        };
    },
    mutations: languageDataMutations,
    actions: languageDataActions,
    getters: languageDataGetters,
};